import React from 'react';
import ClientItem from '../Domain/ClientItem';
import dateTimeHelper from '../Helpers/datetimeHelper';
import serviceHelper from '../Helpers/serviceHelper';
import AuthService from './authService';
import RoleService from './roleService';
import InvoiceAutomationService from './InvoiceAutomationService';
import SearchParams from '../Elements/SearchParams';
import ClientSearchParams from '../Contents/Sales/ClientAdmin/ClientSearchParams';

export default class ClientService extends React.Component {
  static GetClientList(
    clientId,
    clientIdFilter,
    projectIdFilter,
    opportunityIdFilter,
    surveyIdFilter,
    tpProjectIdFilter,
    tpSurveyIdFilter
  ) {
    const searchItem = {
      ClientId: clientIdFilter,
      ProjectId: projectIdFilter,
      OpportunityId: opportunityIdFilter,
      SurveyId: surveyIdFilter,
      TpProjectId: tpProjectIdFilter,
      TpSurveyId: tpSurveyIdFilter,
    };

    let url = '/api/Client';

    if (clientId != null && clientId !== -1) {
      url += `/${clientId}?clearCache=true`;
    } else {
      url += `?searchItem=${JSON.stringify(searchItem)}&clearCache=true`;
    }

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetClientListSlim() {
    const url = '/api/Client/GetAllSlim?clearCache=false';
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetClientListByOffices(officeIds) {
    const url = `/api/Client/GetClientsByOfficesAsync/?officeIds=${JSON.stringify(officeIds)}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetClientListIncludingInactive() {
    const url = '/api/Client/GetAllIncludingInactive?clearCache=true';
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetClientByProjectSassieIdId(SassieId) {
    const authService = AuthService.getInstance();
    let url = `/api/Client/GetClientFromAppolo/${SassieId}`;
    url += `?clearCache=false`;
    return authService.CallBackendFunction(url);
  }

  static UpdateSassieId(ClientId, SassieId, client_name) {
    const authService = AuthService.getInstance();
    let url = `/api/Client/UpdateClientSassieId?ClientId=${ClientId}&SassieId=${SassieId}&ApolloClientName=${client_name}`;
    url += `&clearCache=false`;
    return authService.CallBackendFunctionPut(url);
  }

  static GetClientItemList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(
      searchItem,
      ClientSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );

    const url = `/api/Client/GetAllClient?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  // The Clients list page, with each client's automatic invoicing counts for the roles that may see them.
  static GetClientItemListWithInvoiceAutomation(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const clientPage = ClientService.GetClientItemList(
      orderById,
      orderDir,
      pageNumber,
      numberOfElements,
      searchItem,
      clearCache
    );
    if (!RoleService.CheckUserPermission('datatable', 'invoice_automation_view')) {
      return clientPage;
    }
    return clientPage.then((page) => InvoiceAutomationService.AddClientStatuses(page));
  }

  static ExportAdminExcelAsync(searchItem) {
    const url = `/api/Client/ExportAdminExcelAsync?searchItem=${JSON.stringify(searchItem)}&clearCache=true`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new ClientItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static EditClient(item) {
    item = serviceHelper.ConvertAllPropertyToString(item);
    item.CheckInByDate = dateTimeHelper.toYYYYsMMsDD(item.CheckInByDate);

    const url = item.ClientId === '' ? '/api/Client/PostClientAsync' : '/api/Client/EditClientAsync';

    const JSONItem = JSON.stringify(item);
    return AuthService.getInstance().CallBackendFunctionPost(url, JSONItem);
  }

  static RemoveParent(clientId) {
    const authService = AuthService.getInstance();
    const url = `/api/Client/RemoveParentAsync?clientId=${clientId}`;
    return authService.CallBackendFunctionPut(url);
  }

  static AddParent(clientId, parentClientId) {
    const authService = AuthService.getInstance();
    const url = `/api/Client/AddParentAsync?clientId=${clientId}&parentClientId=${parentClientId}`;
    return authService.CallBackendFunctionPut(url);
  }

  static GetById(clientId) {
    const url = `/api/Client/GetById/${clientId ?? 0}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  // Name-only resolver for ShowNameComponent, which renders the resolved value directly and needs a
  // string (handed an object it renders 'obj'). MUST stay a static method: lookupCache keys on the
  // function's identity, so an inline wrapper would defeat the per-id cache and fire one request
  // per grid row.
  static GetClientNameById(clientId) {
    return ClientService.GetById(clientId).then((client) => client?.name ?? null);
  }

  static AddExternalQuestionaire(
    entityId,
    entityType,
    templateName,
    thanksTemplateName,
    expirationDate,
    submittedTemplateName,
    enableMultipleResponses
  ) {
    const authService = AuthService.getInstance();
    const url = `/api/PersonalizedWebpage/AddExternalQuestionaireAsync`;
    const body = JSON.stringify({
      entityId,
      entityType,
      templateName,
      thanksTemplateName,
      expirationDate,
      submittedTemplateName,
      enableMultipleResponses,
    });
    return authService.CallBackendFunctionPost(url, body);
  }
}
